import React, { useEffect, useState } from 'react';
import {
  StCountTrailCircle,
  StCountTrailCircleLabel,
  StCountTrailContainer,
  StCountTrailWrapper,
  StRichTextGridItem,
} from './CountTrial.styles';
import Grid from '@mui/material/Grid';
import { RichText } from '@sitecore-jss/sitecore-jss-nextjs';
import { useRouter } from 'next/router';
import { useCountTrial } from 'lib/hooks/coveo/useCountTrial';
import featchCountTrailHeadlessEnginee from 'lib/utils/coveo/featchCountTrailHeadlessEnginee';
import { buildQuerySummary } from '@coveo/headless';
import { useSelector, useDispatch } from 'react-redux';
import { setShowAnyLocation } from 'src/features/coveoSlice';
import { RootState } from '../../../store/store';
import ButtonSecondary from '../../../components/shared/Button/SecondaryButton';
import UiBox from '../../../components/shared/Box';
import UiContainer from '../../shared/Container/Container';
import UiSubHeading from '../../../components/shared/Typography/UiSubHeading';

export const mergeTag = (text: string, dataObject: Record<string, any>): string => {
  if (text === undefined) return '';
  const regex = /\[(.*?)\]/g;

  const modifiedText = text.replace(regex, (match, fieldName) => {
    if (dataObject?.hasOwnProperty(fieldName)) {
      return dataObject[fieldName];
    } else {
      return match;
    }
  });

  return modifiedText;
};

const CountTrial: React.FC<any> = (props) => {
  const [trialsList, setTrialsList] = useState<any>([]);
  const [totalTrialCount, setTrialCount] = useState<any>([]);
  const router = useRouter();
  const countLabel = props?.fields?.countLabel;
  const countText = props?.fields?.countText;
  const viewTrialButton = props?.fields?.viewTrialButton;
  const relatedCommunityConditions = props.fields?.relatedCommunityConditions;
  const queryParam = relatedCommunityConditions
    ?.map((condition: any) => condition.key)
    .join(' and ');
  const { data } = useCountTrial(featchCountTrailHeadlessEnginee, queryParam);
  const controller = buildQuerySummary(featchCountTrailHeadlessEnginee);
  const [state, setState] = useState(controller.state);
  const dispatch = useDispatch();
  const showLocationValue = useSelector((state: RootState) => state.coveoResult.showAnyLocation);
  const { countColor, fontColor, countFontWeight } = props?.fields;

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setTrialsList(data?.results);
      controller.subscribe(() => setState(controller.state));
      setTrialCount(state.total);
    }
  }, [data]);

  const handleViewTrials = () => {
    if (relatedCommunityConditions?.length === 0) return;
    const URL = viewTrialButton?.value?.href;

    if (showLocationValue === false) {
      dispatch(setShowAnyLocation());
    }
    router.push(`${URL}#q=${queryParam || ''}&f-trialenrollingstatus=Enrolling`);
  };

  return (
    <StCountTrailWrapper id="count-trial" className="ui-count-trial">
      <StCountTrailContainer className="ui-count-trial__container">
        <UiContainer>
          <Grid container columnSpacing={6} alignItems="center">
            <Grid item md xs={12}>
              <StRichTextGridItem fontColor={fontColor?.value}>
                <RichText field={props?.fields?.trialContent} data-testid="count-trial-content" />
              </StRichTextGridItem>
            </Grid>
            <Grid item md="auto" xs={12}>
              <UiBox
                styles={{
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <StCountTrailCircle direction="column">
                  <UiSubHeading
                    align="center"
                    styles={{
                      color: countColor?.value || '#C6FCFF',
                      fontSize: '60px',
                      fontWeight: countFontWeight?.value || 700,
                      lineHeight: 1.2,
                    }}
                  >
                    {mergeTag(countText?.value, { count: trialsList ? totalTrialCount : 0 })}
                  </UiSubHeading>
                  <StCountTrailCircleLabel>
                    {countLabel?.value || 'RECRUITING TRIALS'}
                  </StCountTrailCircleLabel>
                </StCountTrailCircle>
                <UiBox styles={{ paddingTop: '1.2rem', minWidth: '130px' }}>
                  <ButtonSecondary fullWidth onClick={handleViewTrials}>
                    {viewTrialButton?.value?.text}
                  </ButtonSecondary>
                </UiBox>
              </UiBox>
            </Grid>
          </Grid>
        </UiContainer>
      </StCountTrailContainer>
    </StCountTrailWrapper>
  );
};

export default CountTrial;
